module.exports = __webpack_public_path__ + "img/step_2.2b6a5f21.webp";